import React, { Fragment } from "react";
import classes from "./DenContent.module.css";
import nests from "../../Assets/Data/Nests"; 
import nestContent from "../../Assets/Data/NestContent";
import PlaceName from "../../Util/PlaceName";
import { useTranslation } from 'react-i18next';
import ReactDOMServer from 'react-dom/server';

const denContent = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);

    const prefix = ["b", "IoA", "CT"]
    let nestDropdown = null;
    if (props.activeTab === 0) {
        nestDropdown = (
            <Fragment>
                <p>{t("DENEXPLAIN")}</p>
                <p><strong>{t("DEN")}:</strong></p>
                <select className={classes.Select} onChange={props.denchange} value={props.currentDen} >
                    {
                        nests.map((el, idx) => {
                            return idx === 16 ? null : (<option key={"den_"+idx} value={idx}>{idx >= 190? (idx - 189) : idx >= 100? (idx - 99) : (idx + 1)} [{prefix[idx >= 190? 2 : idx >= 100? 1 : 0]}]: {ReactDOMServer.renderToStaticMarkup(<PlaceName id={el[2]} />)}</option>);
                        })
                    }
                </select>
                <p><strong>{t("RARITY")}:</strong></p>
                <select className={classes.Select} value={props.currentRarity} onChange={props.raritychange}>
                    <option value="0" defaultValue>{t("RARITYNORMAL")}</option>
                    <option value="1">{t("RARITYRARE")}</option>
                </select>
            </Fragment>);
    } else if (props.activeTab === 1) {
        nestDropdown = (
            <Fragment>
                <p>{t("NESTEXPLAIN")}</p>
                <p><strong>{t("NEST")}:</strong></p>
                <select className={classes.Select} onChange={props.nestchange} value={props.currentNest} >
                    {
                        nestContent[props.currentGame].map((_, idx) => {
                            return <option key={"nest_"+idx} value={idx}>{t("NEST")} {(idx + 1)}</option>;
                        })
                    }
                </select>
            </Fragment>);
    } else if (props.activeTab === 2) {
        nestDropdown = (
            <Fragment>
                <p>{t("EVENTEXPLAIN")}</p>
                <p><strong>{t("EVENT")}:</strong></p>
                <select className={classes.Select} onChange={props.eventnestchange} value={props.currentEventNest}>
                    {
                        props.eventData.map((evt, idx) => {
                            const tmp = evt.substring(0, evt.length - 5);
                            return <option key={evt} value={idx}>{tmp.substring(0, 2) + "-" + tmp.substring(2, 4) + "-" + tmp.substring(4)}</option>;
                        })
                    }
                </select>
            </Fragment>);
    } else if (props.activeTab === 3) {
        nestDropdown = (
            <Fragment>
                <p>Isle of Armor Nests</p>
                <p><strong>DLC Nests:</strong></p>
                <select className={classes.Select} onChange={props.dlcnestchange} value={props.currentDLCNest}>
                    {
                        nestContent[props.currentGame].map((_, idx) => {
                            return <option key={"dlcnest_"+idx} value={idx}>DLC {t("NEST")} {(idx + 1)}</option>;
                        })
                    }
                </select>
            </Fragment>);
    }

    return (
        <div className={classes.DenContent}>
            {nestDropdown}
            <p><strong>{t("GAME")}:</strong></p>
            <select className={classes.Select} value={props.currentGame} onChange={props.gamechange}>
                <option value="0" defaultValue>{t("GAMESWORD")}</option>
                <option value="1">{t("GAMESHIELD")}</option>
            </select>
            <p><strong>Pokémon:</strong></p>
            <select className={classes.Select} value={props.currentSelectedPokemon} onChange={props.pokemonChange}>
                {props.currentPkmn}
            </select>
        </div>
    );
}

export default denContent;